import {Component, Input, OnInit} from '@angular/core';
import {environment} from '../../../environments/environment';

@Component({
    selector: 'kkk-email-preview',
    templateUrl: './email-preview.component.html',
    styleUrls: ['./email-preview.component.scss']
})
export class EmailPreviewComponent implements OnInit {

    @Input()
    htmlText: string;

    fe: string;
    logoSrc: string;

    constructor() {
    }

    ngOnInit() {
        this.fe = environment.frontend;
        this.logoSrc = this.fe + '/assets/logo-white-2.png';
    }

}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/email/email-preview/email-preview.component.ts